import { useCallback, useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { auth } from "../services/auth";
import { getPost, deletePost } from "../services/blog";
import Loader from "../shared/Loader";
import { Helmet } from "react-helmet";
import styles from "../css/blog.module.css";

function BlogPost() {
  const [post, setPost] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [config, setConfig] = useState(null);

  const navigate = useNavigate();

  const { id } = useParams();

  useEffect(() => {
    setConfig({
      headers: { Authorization: `Bearer ${auth().getToken()}` },
    });
    setIsAdmin(auth().isAdmin());
  }, []);

  const fetchPost = useCallback(() => {
    if (config) {
      setIsLoading(true);
      getPost(id, config)
        .then((response) => {
          setPost(response.data);
          setIsLoading(false);
        })
        .catch((error) => console.error(error));
    }
  }, [id, config]);

  useEffect(() => {
    fetchPost();
  }, [id, config]);

  function removePost() {
    if (window.confirm("Are you sure you want to delete?")) {
      setDeleting(true);
      deletePost(id, config)
        .then((response) => {
          setPost(response.data);
          setDeleting(true);
          setHasError(false);
          navigate(`/blog`);
        })
        .catch((error) => {
          setHasError(true);
        })
        .finally(() => {
          setDeleting(true);
        });
    }
  }

  return (
    <>
      <Helmet>
        <title>Dailysocialboost | View post</title>
      </Helmet>
      {isLoading ? (
        <div className="flex flex-row self-center justify-center content-center">
          <Loader styles={"w-20 h-20 self-center"}></Loader>{" "}
        </div>
      ) : (
        <article className="my-20">
          <div className="grid grid-cols-2 gap-5">
            <div className="col-span-2 md:col-span-1">
              <img className={styles.blogBigImage} src={post?.image} alt={post?.name} />
            </div>
            <div className="col-span-2 md:col-span-1">
              <div className="flex flex-col justify-center h-full">
                <h2 className="text-6xl font-extrabold">{post?.name}</h2>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-3">
            <div className="col-span-0 md:col-span-2"></div>
            <div className="col-span-12 md:col-span-8">
              <div className="text-justify" dangerouslySetInnerHTML={{ __html: post?.description }} />
              {isAdmin ? (
                <>
                  <div className="flex flex-row justify-between mt-3">
                    <Link to={`/blog/edit/${post?.id}`} className={styles.editPostBtn}>
                      Edit
                    </Link>
                    <button
                      disabled={deleting}
                      onClick={() => removePost(post?.id)}
                      className={styles.deletePostBtn}
                    >
                      Delete
                    </button>
                  </div>
                  <div className="flex flex-row justify-end mt-3">
                    {hasError ? <p className="text-red-600">Failed deleting post.</p> : null}
                  </div>
                </>
              ) : null}
            </div>
            <div className="col-span-0 md:col-span-2">
            </div>
          </div>
        </article>
      )}
    </>
  );
}

export default BlogPost;
